import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Arrow from '../../assets/images/icons/down-arrow.svg';
import Logo from '../../assets/images/floquote-logo.svg';
import './PublicPageWrapper.scss';

const PublicPageWrapper = ({showRedirect = false, redirectClicked = undefined, children = undefined, className = '', logoClicked = undefined, logoClickable = false}) => (
  <div className={`public-page-wrapper position-relative ${className}`}>
    <div
      className="public-page-wrapper__header position-relative"
    >
      <button
        className="d-block d-flex public-page-wrapper__logo-container"
        type="button"
        aria-label="Navigate to auth page"
        onClick={logoClicked}
        disabled={!logoClickable}
      >
        <Logo className="public-page-wrapper__logo" />
      </button>
      {showRedirect && (
      <Button
        type="button"
        variant="link"
        className="public-page-wrapper__redirect text-decoration-none"
        onClick={redirectClicked}
      >
        <Arrow className="public-page-wrapper__redirect-icon mr-2" />
        Back to app
      </Button>
      )}
    </div>
    {children}
    <div className="public-page-wrapper__copyright">
      Copyright © 2020 FloQuote. All Rights Reserved
    </div>
  </div>
);

const {
  node, bool, string, func,
} = PropTypes;

PublicPageWrapper.propTypes = {
  showRedirect: bool,
  children: node,
  redirectClicked: func,
  className: string,
  logoClicked: func,
  logoClickable: bool,
};
export default PublicPageWrapper;
